"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _typography = _interopRequireDefault(require("@decisiv/design-tokens/lib/typography"));

var _Sort = _interopRequireDefault(require("@decisiv/iconix/lib/components/Sort"));

var _SortAsc = _interopRequireDefault(require("@decisiv/iconix/lib/components/SortAsc"));

var _SortDesc = _interopRequireDefault(require("@decisiv/iconix/lib/components/SortDesc"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _BaseButton = _interopRequireDefault(require("../../../atoms/BaseButton"));

var _focusRingWithColor = _interopRequireDefault(require("../../../utils/focusRingWithColor"));

var _styleModifiers = require("../../../utils/styleModifiers");

var _usePrevious = _interopRequireDefault(require("../../../utils/usePrevious"));

var _useTranslations = _interopRequireDefault(require("../../../utils/useTranslations"));

var _useUniqueId = _interopRequireDefault(require("../../../utils/useUniqueId"));

var _useSortableHeaders = require("../hooks/useSortableHeaders");

var _Provider = require("../Provider");

var _iconsForSortingType;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var iconsForSortingType = (_iconsForSortingType = {}, _defineProperty(_iconsForSortingType, _useSortableHeaders.ASCENDING, _SortAsc.default), _defineProperty(_iconsForSortingType, _useSortableHeaders.DESCENDING, _SortDesc.default), _defineProperty(_iconsForSortingType, _useSortableHeaders.UNSORTED, _Sort.default), _iconsForSortingType);
/**
 * This React hook determines the Sorting Icon and its aria-label based on the
 * current sorting context.
 */

function useSortingIcon(isSortingColumn, sortingType) {
  var translate = (0, _useTranslations.default)();

  if (isSortingColumn) {
    return [iconsForSortingType[sortingType || _useSortableHeaders.UNSORTED], translate(undefined, "table.sortIcons.aria[".concat(sortingType, "]"))];
  }

  return [iconsForSortingType[_useSortableHeaders.UNSORTED], translate(undefined, "table.sortIcons.aria[".concat(_useSortableHeaders.UNSORTED, "]"))];
}

/**
 * This React hook determines some props required but the SortableHeaderCell
 * based on the current sorting context.
 */
function useSortableHeader(name, sortBy) {
  var _React$useContext = _react.default.useContext(_Provider.TableContext),
      sort = _React$useContext.sort,
      sortingColumn = _React$useContext.sortingColumn,
      sortingType = _React$useContext.sortingType;

  var prevOnSort = (0, _usePrevious.default)(sortBy);
  var prevSortingColumn = (0, _usePrevious.default)(sortingColumn);
  var prevSortingType = (0, _usePrevious.default)(sortingType);
  var isSortingColumn = name === sortingColumn && sortingType !== _useSortableHeaders.UNSORTED; // This is done using an effect instead of in the onClick handler because the sortingType isn't
  // advanced until it is updated in context, then it trickles down. The sortBy function needs
  // to be called with what the _next_ sortingType is, not what it was.

  _react.default.useEffect(function () {
    var hasRerendered = prevOnSort !== sortBy;
    var isSortingColumnChanged = prevSortingColumn !== sortingColumn;
    var isSortingTypeChanged = prevSortingType !== sortingType; // This conditional is only truthy when a user clicks a column header (changing the
    // sortingColumn and/or sortingType). It should only run once per click.

    if (!hasRerendered && (isSortingColumnChanged || isSortingTypeChanged) && name === sortingColumn) {
      sortBy(sortingType || _useSortableHeaders.UNSORTED);
    }
  }, [prevOnSort, prevSortingColumn, prevSortingType, name, sortBy, sortingColumn, sortingType]);

  var _useSortingIcon = useSortingIcon(isSortingColumn, sortingType),
      _useSortingIcon2 = _slicedToArray(_useSortingIcon, 2),
      SortingIcon = _useSortingIcon2[0],
      sortingIconLabel = _useSortingIcon2[1];

  return {
    SortingIcon: SortingIcon,
    isSortingColumn: isSortingColumn,
    onClick: function onClick() {
      return sort(name);
    },
    sortingIconLabel: sortingIconLabel
  };
}

var SortIconContainer = _styledComponents.default.span.withConfig({
  displayName: "SortableHeaderCell__SortIconContainer",
  componentId: "r45267-0"
})(["color:", ";"], (0, _toColorString.default)(_color.default.interaction.pacificOcean));

var SortableHeaderCellButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "SortableHeaderCell__SortableHeaderCellButton",
  componentId: "r45267-1"
})(["font-size:", ";font-weight:", ";background:transparent;border:1px solid transparent;display:flex;flex-direction:column;text-align:left;text-transform:uppercase;width:calc(100% + 20px);> div{flex:1;> span{margin-right:5px;}}&:active,&:focus{", ";border-color:", ";outline:none;}&:hover{background-color:", ";color:", ";", "{color:", ";}}", ";"], (0, _rem.default)(_typography.default.size.alias.paragraph2), _typography.default.weight.alias.semibold, (0, _focusRingWithColor.default)(_color.default.interaction.pacificOcean40), (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _toColorString.default)(_color.default.base.snowWhite), SortIconContainer, (0, _toColorString.default)(_color.default.base.snowWhite), (0, _styleModifiers.when)('status', 'active', (0, _styledComponents.css)(["background-color:", ";"], (0, _toColorString.default)(_color.default.interaction.pacificOcean15))));

function SortableHeaderCell(_ref) {
  var name = _ref.name,
      sortBy = _ref.sortBy,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, ["name", "sortBy", "title"]);

  var _useSortableHeader = useSortableHeader(name, sortBy),
      SortingIcon = _useSortableHeader.SortingIcon,
      isSortingColumn = _useSortableHeader.isSortingColumn,
      onClick = _useSortableHeader.onClick,
      sortingIconLabel = _useSortableHeader.sortingIconLabel;

  var sortingIconId = (0, _useUniqueId.default)(undefined, 'table-sorting-icon-');
  return _react.default.createElement(SortableHeaderCellButton, _extends({}, rest, {
    "aria-describedby": sortingIconId,
    className: "fluid" // This class makes the cell's contents take up the full width
    ,
    type: "button",
    status: isSortingColumn ? 'active' : undefined,
    onClick: onClick
  }), _react.default.createElement("div", null, _react.default.createElement("span", null, title), _react.default.createElement(SortIconContainer, {
    "aria-label": sortingIconLabel,
    id: sortingIconId,
    role: "img"
  }, _react.default.createElement(SortingIcon, {
    width: 12,
    height: 12
  }))));
}

var _default = _react.default.memo(SortableHeaderCell);

exports.default = _default;